import {Humanize} from "vendor/humanize";

import "./index.scss";

export default () => {
  $('.search-page').each((index, component) => {
    const $component = $(component);
    const $descriptions = $component.find('.search-item-description');
    const $searchInput = $('.sb-search-input');
    const searchTerm = $component.data('search-term');

    $searchInput.val(searchTerm);

    $descriptions.each((index, description) => {
      const $description = $(description);
      const $texts = $description.find('p');
      const content = $texts.text();
      const text = Humanize.truncateWords(content, 40);

      $texts.text(text != null ? text : content);
    });

    $descriptions.mark(searchTerm, {
      "each": function (element) {
        setTimeout(function () {
          $(element).addClass("animate");
        }, 250);
      }
    });
  });
}
